module.exports = __webpack_public_path__ + "static/media/Tips_para_comprar_un_0km.90fe3420.pdf";